<script setup>
import {onMounted, reactive} from "vue";
import {tt} from '@/i18n';
import ContentList from "@/components/list/ContentList";
import SearchBar from "@/components/library/SearchBar";
import LoadingSpinner from "../shared/LoadingSpinner";
import {useLibraryStore} from "@/stores/LibraryStore";
import useFilteredLibrary from "@/composables/useFilteredLibrary";

const store = useLibraryStore();

const state = reactive({
    myQuest: "library",
    loading: false,
});

const {filteredLibrary, searchTerm} = useFilteredLibrary(store);

async function loadLibrary() {
    state.loading = true;
    await store.getLibraryContent();
    document.title = tt('tab_title__content_library');
    state.loading = false;
}

onMounted(() => {
    loadLibrary()
});
</script>

<template>
    <div class="bg-[#FBFBFD]">
        <loading-spinner v-if="state.loading"/>
        <div v-else>
            <search-bar
                v-model="searchTerm"
                class="mt-16 mb-11 mx-auto w-full lg:w-7/12"
            ></search-bar>
            <content-list :content_list="filteredLibrary"/>
        </div>
    </div>
</template>
